function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// @mui imports
import MuiDivider from "@mui/material/Divider";
const Divider = ({
  id = "divider-default-id",
  variant = "fullWidth",
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(MuiDivider, _extends({
    id: id,
    variant: variant
  }, rest));
};
Divider.propTypes = {
  id: PropTypes.string,
  variant: PropTypes.string
};
export default Divider;